@if (fileId || file) {
  <div>
    <span class="filename" *ngIf="fileName">{{ fileName | tmwAbbreviate: 20 }}</span>

    @if (!readOnlyInput) {
    <a class="btn btn-sm text-danger m-x-xs" (click)="deleteFile()">
      <i class="bi bi-trash-fill"></i>
    </a>
  }
    <a class="btn btn-sm text-success m-x-xs" (click)="openFile()">
      <i class="bi bi-download"></i>
    </a>

  </div>
} @else {
  <div class="upload-file">
    <input type="text" class="file-name form-control form-control-sm" [value]="fileName" readonly="readonly" />
    @if (!readOnlyInput) {

    <input
      type="file"
      id="file"
      (change)="setFileData($event)"
      style="display: none"
      #fileUpload
    />
    <span class="browse" (click)="fileUpload.click()">
      <i class="bi bi-upload"></i>
    </span>

  }
  </div>
}
